module.exports = __webpack_public_path__ + "images/file_icons_v2/doc-77abfcca8d28529c01cd3fe669f10688.svg";